// API Key 权限统一在这里声明。Key 本身不分类型；每项能力都通过 scope
// 独立 opt-in，已有的普通 XAPI 调用能力不受这些开关影响。
export const KEY_PERMS = [
  {
    groupKey: "console.keys.permissions.groups.runtime.title",
    noteKey: "console.keys.permissions.groups.runtime.note",
    items: [
      {
        id: "agent:runtime",
        labelKey: "console.keys.permissions.runtime.label",
        descKey: "console.keys.permissions.runtime.desc",
      },
    ],
  },
  {
    groupKey: "console.keys.permissions.groups.workers.title",
    items: [
      {
        id: "workers:read",
        labelKey: "console.keys.permissions.workersRead.label",
        descKey: "console.keys.permissions.workersRead.desc",
      },
      {
        id: "workers:write",
        labelKey: "console.keys.permissions.workersWrite.label",
        descKey: "console.keys.permissions.workersWrite.desc",
      },
    ],
  },
  {
    groupKey: "console.keys.permissions.groups.sandbox.title",
    items: [
      {
        id: "sandbox",
        labelKey: "console.keys.permissions.sandbox.label",
        descKey: "console.keys.permissions.sandbox.desc",
      },
    ],
  },
  {
    groupKey: "console.keys.permissions.groups.agent.title",
    noteKey: "console.keys.permissions.groups.agent.note",
    items: [
      {
        id: "service:create",
        labelKey: "console.keys.permissions.serviceCreate.label",
        descKey: "console.keys.permissions.serviceCreate.desc",
      },
      {
        id: "service:read",
        labelKey: "console.keys.permissions.serviceRead.label",
        descKey: "console.keys.permissions.serviceRead.desc",
      },
      {
        id: "service:update",
        labelKey: "console.keys.permissions.serviceUpdate.label",
        descKey: "console.keys.permissions.serviceUpdate.desc",
      },
      {
        id: "version:create",
        labelKey: "console.keys.permissions.versionCreate.label",
        descKey: "console.keys.permissions.versionCreate.desc",
      },
      {
        id: "service:publish",
        labelKey: "console.keys.permissions.servicePublish.label",
        descKey: "console.keys.permissions.servicePublish.desc",
        danger: true,
      },
      { id: "service:rollback", labelKey: "console.keys.permissions.serviceRollback.label", descKey: "console.keys.permissions.serviceRollback.desc" },
      {
        id: "service:delete",
        labelKey: "console.keys.permissions.serviceDelete.label",
        descKey: "console.keys.permissions.serviceDelete.desc",
        danger: true,
      },
    ],
  },
  {
    groupKey: "console.keys.permissions.groups.skills.title",
    noteKey: "console.keys.permissions.groups.skills.note",
    items: [
      {
        id: "skill:read",
        labelKey: "console.keys.permissions.serviceRead.label",
        descKey: "console.keys.permissions.skillRead.desc",
      },
      { id: "skill:create", labelKey: "console.keys.permissions.skillCreate.label", descKey: "console.keys.permissions.skillCreate.desc" },
      {
        id: "skill:update",
        labelKey: "console.keys.permissions.skillUpdate.label",
        descKey: "console.keys.permissions.skillUpdate.desc",
      },
      {
        id: "skill:submit",
        labelKey: "console.keys.permissions.skillSubmit.label",
        descKey: "console.keys.permissions.skillSubmit.desc",
        danger: true,
      },
    ],
  },
];

export const visibleKeyPerms = (canUseXntCloud) =>
  KEY_PERMS.map((group) => ({
    ...group,
    items: group.items.filter(
      (item) => item.id !== "agent:runtime" || canUseXntCloud,
    ),
  })).filter((group) => group.items.length > 0);

export const toggleScope = (scopes, scope) => {
  const current = [...new Set(Array.isArray(scopes) ? scopes : [])];
  return current.includes(scope)
    ? current.filter((item) => item !== scope)
    : [...current, scope];
};

export const isPermOn = (key, id) =>
  id === "sandbox"
    ? !!key.sandbox
    : (Array.isArray(key.scopes) ? key.scopes : []).includes(id);

export const enabledPermCount = (key) =>
  (key.sandbox ? 1 : 0) +
  (Array.isArray(key.scopes) ? key.scopes.length : 0);
